/**
 * api.ts — URL del backend Express según el contexto de ejecución.
 *
 * El problema Docker:
 *  - Browser (client-side):  corre en el HOST → accede a localhost:8080 ✅
 *  - Next.js API routes (server-side): corren DENTRO del container frontend
 *    → localhost:8080 no existe ahí → necesitan el nombre del servicio Docker: api:8080
 *
 * Solución:
 *  - NEXT_PUBLIC_API_URL  → para componentes React (browser)
 *  - API_URL_INTERNAL     → para Next.js Route Handlers (server-side en Docker)
 *
 * En desarrollo local sin Docker, ambas apuntan a localhost:8080.
 */

/** URL a usar desde Route Handlers de Next.js (server-side) */
export const API_URL_SERVER =
  process.env.API_URL_INTERNAL ??
  process.env.NEXT_PUBLIC_API_URL ??
  'http://localhost:8080/api';

/** URL a usar desde componentes React (client-side, browser) */
export const API_URL_CLIENT =
  process.env.NEXT_PUBLIC_API_URL ??
  'http://localhost:8080/api';
